import { Button } from '@/components/ui/button';

import AlertPresetGlyph from './AlertPresetGlyph';
import { ALERT_PRESETS, AlertPreset } from './alertPresets';
import { ALERT_TEXT_NAMESPACE } from './alertPlaceholders';
import { Translate } from './AlertActionEditor';

/**
 * "What should be reported?" — a short choice of common cases before the editor opens.
 * Each card pre-fills the condition and a default message; every value stays editable.
 */
export default function AlertPresetChooser(properties: {
    t: Translate;
    onChoose: (preset: AlertPreset) => void;
    onCancel: () => void;
}) {
    const { t } = properties;

    return (
        <section aria-labelledby="alert-preset-title" className="flex min-w-0 flex-col gap-4">
            <div className="flex flex-wrap items-center gap-3">
                <div className="min-w-0 flex-1">
                    <h3 id="alert-preset-title" className="text-lg font-semibold">{t(`${ALERT_TEXT_NAMESPACE}chooseTitle`)}</h3>
                    <p className="text-sm text-muted-foreground">{t(`${ALERT_TEXT_NAMESPACE}chooseHint`)}</p>
                </div>
                <Button variant="outline" className="max-sm:w-full" onClick={properties.onCancel}>
                    {t(`${ALERT_TEXT_NAMESPACE}cancel`)}
                </Button>
            </div>
            <ul className="grid min-w-0 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {ALERT_PRESETS.map((preset) => {
                    return (
                        <li key={preset.id} className="min-w-0">
                            <button
                                type="button"
                                data-preset={preset.id}
                                className="alert-glyph-host flex h-full w-full min-w-0 items-start gap-3 rounded-xl border bg-card p-4 text-left shadow-sm transition-colors hover:border-foreground/40 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                                onClick={() => properties.onChoose(preset)}
                            >
                                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 p-1">
                                    <AlertPresetGlyph id={preset.id} />
                                </span>
                                <span className="flex min-w-0 flex-col gap-0.5">
                                    <span className="font-medium">{t(`${ALERT_TEXT_NAMESPACE}preset.${preset.id}.title`)}</span>
                                    <span className="text-sm text-muted-foreground">{t(`${ALERT_TEXT_NAMESPACE}preset.${preset.id}.example`)}</span>
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </section>
    );
}
